import React, { useEffect } from 'react';
import 'react-toastify/dist/ReactToastify.css';
import '../../index.css';
import { useNavigate } from 'react-router-dom';
import { LoginV3FlowProvider, LoginV3FlowView } from '@/components/Login/v3';
import { useData } from '../../context/DataContext';

const LoginFlow = () => {
    const auth_token = localStorage.getItem('auth_token');
    const navigate = useNavigate();
    const { refreshSettings } = useData();

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const isAppFromURL = params.get('from_app');
        if (auth_token && !isAppFromURL) {
            navigate('/calendar', { replace: true }); // Prevents adding duplicate history entries
            // Ensure Redux store is hydrated before calling refreshSettings
            setTimeout(() => {
                refreshSettings();
            }, 1500);
        } else {
            localStorage.setItem('language', 'da');
        }
    }, [auth_token, navigate, refreshSettings]);

    return (
        <LoginV3FlowProvider>
            <div className="relative min-h-screen">
                <LoginV3FlowView />
            </div>
        </LoginV3FlowProvider>
    );
};

export default LoginFlow;
